<template>
  <div v-if="this.xinli[0]" class="section">
    <div class="title-level2">
      心理健康的个体能避免消极因素带来的困扰，保持持续的、积极发展的心理状态，对内完善自我，对外适应环境。
    </div>
    <div style="display: flex; position: relative">
      <div>
        <div class="content" v-for="(item, index) in this.xinli" :key="index">
          <table cellpadding="1" cellspacing="0" v-if="item.name == '工作倦怠'">
            <tr>
              <td style="background-color: #68c6ef">
                <div class="title-icon" style="background-color: #68c6ef"></div>
              </td>
              <td>
                <div class="content-title" style="color: #68c6ef">
                  {{ item.name }}
                </div>
              </td>
              <td>
                <div class="content-describe" style="width: 350px">
                  {{ item.describe }}
                </div>
              </td>
              <td>
                <heartBar
                  :model="item.level2"
                  :name1="item.name"
                  :score1="item.score"
                />
              </td>
            </tr>
          </table>

          <table cellpadding="1" cellspacing="0" v-if="item.name == '情绪稳定'">
            <tr>
              <td style="background-color: #ec756e">
                <div class="title-icon" style="background-color: #ec756e"></div>
              </td>
              <td>
                <div class="content-title" style="color: #ec756e">
                  {{ item.name }}
                </div>
              </td>
              <td>
                <div class="content-describe" style="width: 350px">
                  {{ item.describe }}
                </div>
              </td>
              <td>
                <heartBarQ
                  :model="item.level2"
                  :name1="item.name"
                  :score1="item.score"
                />
              </td>
            </tr>
          </table>
          <table cellpadding="1" cellspacing="0" v-if="item.name == '积极心理'">
            <tr>
              <td style="background-color: #f6b452">
                <div class="title-icon" style="background-color: #f6b452"></div>
              </td>
              <td>
                <div class="content-title" style="color: #f6b452">
                  {{ item.name }}
                </div>
              </td>
              <td>
                <div class="content-describe" style="width: 350px">
                  {{ item.describe }}
                </div>
              </td>
              <td>
                <heartBarJ
                  :model="item.level2"
                  :name1="item.name"
                  :score1="item.score"
                />
              </td>
            </tr>
          </table>

          <table cellpadding="1" cellspacing="0" v-if="item.name == '心理症状'">
            <tr>
              <td style="background-color: #a1d46b">
                <div class="title-icon" style="background-color: #a1d46b"></div>
              </td>
              <td>
                <div class="content-title" style="color: #a1d46b">
                  {{ item.name }}
                </div>
              </td>
              <td>
                <div class="content-describe" style="width: 350px">
                  {{ item.describe }}
                </div>
              </td>
              <td>
                <heartBarX
                  :model="item.level2"
                  :name1="item.name"
                  :score1="item.score"
                />
              </td>
            </tr>
          </table>

          <table cellpadding="1" cellspacing="0" v-if="item.name == '人际和谐'">
            <tr>
              <td style="background-color: #8a83e8">
                <div class="title-icon" style="background-color: #8a83e8"></div>
              </td>
              <td>
                <div class="content-title" style="color: #8a83e8">
                  {{ item.name }}
                </div>
              </td>
              <td>
                <div class="content-describe" style="width: 350px">
                  {{ item.describe }}
                </div>
              </td>
              <td>
                <heartBarR
                  :model="item.level2"
                  :name1="item.name"
                  :score1="item.score"
                />
              </td>
            </tr>
          </table>

          <table cellpadding="1" cellspacing="0" v-if="item.name == '适应耐挫'">
            <tr>
              <td style="background-color: #8799a2">
                <div class="title-icon" style="background-color: #8799a2"></div>
              </td>
              <td>
                <div class="content-title" style="color: #8799a2">
                  {{ item.name }}
                </div>
              </td>
              <td>
                <div class="content-describe" style="width: 350px">
                  {{ item.describe }}
                </div>
              </td>
              <td>
                <heartBarS
                  :model="item.level2"
                  :name1="item.name"
                  :score1="item.score"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>

      <img
        :src="images.line"
        :style="{ height: height + 'px' }"
        class="chart-line"
      />
    </div>
  </div>
</template>

<script>
import heartBar from "@/components/dataView/echarts/all/heartBarAll/heartBar.vue";
import heartBarQ from "@/components/dataView/echarts/all/heartBarAll/heartBarQ.vue";
import heartBarJ from "@/components/dataView/echarts/all/heartBarAll/hearBarJ.vue";
import heartBarX from "@/components/dataView/echarts/all/heartBarAll/heartBarX.vue";
import heartBarR from "@/components/dataView/echarts/all/heartBarAll/heartBarR.vue";
import heartBarS from "@/components/dataView/echarts/all/heartBarAll/heartBarS.vue";

export default {
  components: {
    heartBar,
    heartBarQ,
    heartBarJ,
    heartBarX,
    heartBarR,
    heartBarS,
  },
  props: ["xinli", "height"],
  data() {
    return {
      images: {
        line: require("../../../assets/images/all/line.png"),
      },
    };
  },
  mounted() {
    // if(this.xinli.length  == 1){
    //   this.height = 100;
    // }
    //   if(this.xinli.length  == 2){
    //   this.height = 248;
    // }
    //   if(this.xinli.length  == 3){
    //   this.height = 390;
    // }
    //   if(this.xinli.length  == 4){
    //   this.height = 500;
    // }
    //   if(this.xinli.length  == 5){
    //   this.height = 630;
    // }
    //   if(this.xinli.length  == 6){
    //   this.height = 757;
    // }
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-size: cover;
  background-image: url("../../../assets/images/all/bg3.png");
  height: 1124px;
  overflow: hidden;
  .chart-line {
    width: 25%;
    float: right;
    position: absolute;
    right: 56px;
    z-index: 9;
    top: 0;
  }
  .title-level2 {
    padding: 270px 0 50px 0;
    text-align: center;
    font-size: 14px;
  }
  .content {
    margin-left: 38px;
    border-radius: 10px 0 0 10px;
    background-color: #f9f9fa;
    width: 90.7%;
    margin-top: 7px;
    .title-icon {
      border-radius: 10px 0 0 10px;
      height: 100px;
      width: 17px;
    }
    .content-title {
      padding: 0px 20px 0px 10px;
      font-weight: bold;
      width: 40px;
      margin: 0 auto;
      font-size: 15px;
    }
    .content-describe {
      padding: 0px 30px 0px 10px;
      font-size: 14px;
      width: 350px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/four/pageFour.vue